import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { pcmpProjectQueryKeys, updatePcmpProject } from '../api/pcmpProjects.api';
import type { PcmpProjectPayload } from '../types/pcmpProject.types';

export function useUpdatePcmpProject(projectId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpProjectPayload) => updatePcmpProject(projectId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: pcmpProjectQueryKeys.detail(projectId) });
      toast.success('Project updated');
      onSuccess();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update the project');
    },
  });
}
